import { useState, useEffect } from 'react'
import { getStatusAPI } from '../services/contract'

function UseContractStatus() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getStatusAPI()
      if (!result) return

      const newData = [
        { value: "", label: "All" }, 
        ...result.result.map((d, i) => ({ value: d.id, label: d.status_en })),
        // return { value: d.id, label: d.status_th }
      ]

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseContractStatus
